module.exports = __webpack_public_path__ + "img/k05.64461ca4.png";